import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarTearOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCalendarTearOff"><Path d="M7 2H8.5V4.05882H15.5V2H17V4.05882H21V7.22537L18.145 7.963L14.3133 7.41659L13.3665 8.36174L10.9922 7.41372L7.85744 8.45677L3 7.07852V4.05882H7V2Z" fill="currentColor"/><Path d="M3 8.63773V21H21V8.77462L18.23 9.49029L14.843 9.00729L13.7273 10.121L10.9453 9.01016L7.89256 10.0259L3 8.63773Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarTearOff;
